export const SIGNUP_CPF_FIELDS_EVENTS = {
  FIELD_VALIDATION_ERROR: 'UserAccount.SignupCpfFieldValidationError',
} as const

export const SIGNUP_CPF_FIELDS = ['cpf', 'birthdate', 'phone'] as const

export type SignupCpfField = (typeof SIGNUP_CPF_FIELDS)[number]

// Why the field failed, derived from the predicates the form already runs:
// - empty: submitted with no value
// - incomplete: fewer digits than the mask requires (a CPF under 11 digits is
//   neither empty nor arithmetically invalid)
// - invalid: complete but rejected by validateCpf/validateBirthDate
// - required_for_optin: WhatsApp opt-in checked without a usable phone
//
// A birth date under the minimum age is NOT listed here: it already has its own
// event (UserAccount.BelowMinimumAgeBlocked), which now carries the variant.
export const SIGNUP_CPF_FIELD_ERROR_REASONS = [
  'empty',
  'incomplete',
  'invalid',
  'required_for_optin',
] as const

export type SignupCpfFieldErrorReason = (typeof SIGNUP_CPF_FIELD_ERROR_REASONS)[number]
